import React, { useState, useEffect } from "react";
import { useAuthContext } from "../../../../Context/AuthContext";
import ImageUploading from "react-images-uploading";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import flowChangerLogo from "../../../../Assets/Images/flowchangerAINew.jpeg";
import { useGlobalContext } from "../../../../Context/GlobalContext";
import loginSlash from "../../../../Assets/Images/login-slash.jpeg";
import loginLady from "../../../../Assets/Images/login-lady.png";
import { Link } from "react-router-dom"

const Step7 = () => {
  const { baseUrl, openToast,
  } = useGlobalContext();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  console.log(email)
  const navigate = useNavigate();
  const { extraInfo, updateExtraInfo, setIsAuthenticated } = useAuthContext();
  console.log(extraInfo)
  const [companyLogo, setCompanyLogo] = useState(null);
  console.log(updateExtraInfo);
  console.log(extraInfo);
  useEffect(() => {
    if (email) {
      updateExtraInfo({ email });
    }
  }, [email]);

  const handleExtraInfo = () => {
    updateAdmin();
  };

  // Post request function
  async function updateAdmin() {
    const infoData = new FormData();
    console.log(infoData);
    for (const key in extraInfo) {
      infoData.append(key, extraInfo[key]);
    }
    try {
      const response = await fetch(baseUrl + "admin/update", {
        method: "PUT",
        body: infoData,
      });
      if (response.status === 200) {
        const result = await response.json();
        const { token } = result;
        if (token) {
          Cookies.set("flowChangerAuthToken", token);
          setIsAuthenticated(true);
          navigate("/dashboard");
          openToast("Welcome To Dashboard");
        }
      } else {
        console.log("Error while submitting data");
      }
    } catch (error) {
      console.log(error);
    }
  }

  // Handle image change
  const onChange = (imageList) => {
    if (imageList.length > 0) {
      setCompanyLogo(imageList[0].data_url);
      handleNextStep(imageList[0].data_url);
    }
  };

  const handleNextStep = (image) => {
    if (image) {
      updateExtraInfo({ company_logo: image });
      console.log("Profile image saved in context:", image);
    }
  };

  return (
    <div className="flex justify-center items-center px-[10px] md:px-[20px] lg:px-[20px] xl:px-[20px] py-[10px] md:py-[20px] lg:py-[20px] xl:py-[20px] min-h-screen">
      <div className="flex justify-center bg-white rounded-lg w-[100%] lg:w-[100%] xl:w-[80%] login-div">
        <div className="py-[40px] w-[100%] md:w-1/2 xl:w-[50%]">
          <div className="flex flex-col justify-center items-center gap-y-0">
            <div className="flex justify-center items-center mt-2">
              <img src={flowChangerLogo} className="w-[120px]" />
            </div>
            <h2 className="mt-5 mb-3 font-medium text-2xl text-center">
              Upload Your Company Logo
            </h2>
          </div>

          <div className="flex justify-center items-center">
            {companyLogo ? (
              <img
                src={companyLogo}
                alt="Profile Preview"
                className="mb-4 rounded-full w-[80px] h-[80px] object-cover"
              />
            ) : (
              // <div className="flex justify-center items-center bg-gray-200 mb-4 rounded-full w-[80px] h-[80px]">
              //   <h1 className="left-5 font-medium text-black text-3xl">K</h1>
              // </div>
              ""
            )}
          </div>

          <ImageUploading
            multiple={false}
            onChange={onChange}
            dataURLKey="data_url"
          >
            {({ onImageUpload, dragProps }) => (
              <div className="flex justify-center items-center">
                <button
                  onClick={onImageUpload}
                  className="bg-[#8a25b0] hover:bg-[#884a9f] px-4 py-3 border-[#8a25b1] rounded-full outline-none w-[290px] font-medium text-white transition duration-300"
                  {...dragProps}
                >
                  Choose Image
                </button>
              </div>
            )}
          </ImageUploading>

          <div className="mt-4 text-center">
            <div className="flex justify-center items-center">
              <Link to="/dashboard"
                onClick={handleExtraInfo}
                className="text-[#884a9f] hover:text-[#884a9f]"
              >
                Skip the step
              </Link>
            </div>
          </div>
        </div>

        <div className="hidden login-right right-side relative md:flex justify-center items-center bg-[#9181F4] px-[30px] py-[10px] w-[50%] md:w-1/2 lg:w-[50%] xl:w-[50%] text-4xl text-center">
          <div className="relative bg-[#e2e0e938] border border-[#bfbfbf66] rounded-xl w-[80%] h-[83%]">
            <h2 className="p-[18px] w-[212px] font-bold text-[32px] text-white md:text-[22px] text-left">
              Upload your company logo for a professional touch!!
            </h2>
            <div className="top-[33px] right-[-42px] absolute">
              <img src={loginLady} alt="loginLady" className="h-[280px]" />
            </div>
            <div className="left-[-20px] absolute bg-white p-[10px] rounded-full">
              <img src={loginSlash} alt="loginSlash" className="rounded-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step7;
